export default ["color", "type", "tags", "date"];
